import { jsx as e, jsxs as l } from "react/jsx-runtime";
import { OldCloseIcon as y, InfoIcon as k, CheckmarkIcon as C, AlertIcon as _, ErrorIcon as w } from "../../icons/index.es.js";
import { useCallback as z } from "react";
import { Paragraph as f } from "../../atoms/Paragraph/Paragraph.es.js";
import { ThemeMode as D } from "../../atoms/ThemeMode/ThemeMode.es.js";
import { Button as m, IconButton as b } from "../../atoms/Button/Button.es.js";
import { useColorModeValue as A, useMultiStyleConfig as B, chakra as n } from "@chakra-ui/react";
const M = {
  default: null,
  info: k,
  success: C,
  warning: _,
  error: w
};
function G(p) {
  const {
    children: x,
    title: o,
    primaryAction: s,
    secondaryAction: a,
    variant: r = "default",
    isInline: i = !1,
    isFullWidth: h = !1,
    onClickClose: c,
    ...g
  } = p, u = A("light", "dark"), t = B("NotificationTheme", { variant: r }), I = z(
    (v) => /* @__PURE__ */ e(v, { sx: t.icon }),
    [t.icon]
  ), d = !!o;
  return /* @__PURE__ */ e(D, { mode: r === "default" ? u === "dark" ? "light" : "dark" : "light", children: /* @__PURE__ */ l(
    n.div,
    {
      display: "flex",
      alignItems: d && !i ? "flex-start" : "center",
      __css: {
        ...t.box,
        ...h && {
          rounded: 0,
          width: "full"
        }
      },
      ...g,
      children: [
        /* @__PURE__ */ l(
          n.div,
          {
            display: "flex",
            __css: t.content,
            flexDir: "row",
            alignItems: d && !i ? "flex-start" : "center",
            flexGrow: 1,
            children: [
              r !== "default" && /* @__PURE__ */ e(n.div, { display: "flex", children: I(M[r]) }),
              /* @__PURE__ */ l(
                n.div,
                {
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "spacing-200",
                  flexDirection: i ? "row" : "column",
                  alignSelf: i ? "center" : "flex-start",
                  children: [
                    /* @__PURE__ */ l(
                      n.div,
                      {
                        display: "flex",
                        flexDirection: i ? "row" : "column",
                        alignItems: "flex-start",
                        gap: "spacing-50",
                        alignSelf: i ? "center" : "flex-start",
                        children: [
                          o && /* @__PURE__ */ e(f, { __css: t.title, size: "md", fontWeight: "medium", as: "span", children: o }),
                          /* @__PURE__ */ e(f, { __css: t.title, fontWeight: "normal", as: "span", children: x })
                        ]
                      }
                    ),
                    s && /* @__PURE__ */ l(n.div, { gap: "spacing-100", display: "flex", flexDirection: "row", children: [
                      a && /* @__PURE__ */ e(m, { size: "sm", variant: "transparent", ...a }),
                      /* @__PURE__ */ e(m, { size: "sm", ...s })
                    ] })
                  ]
                }
              )
            ]
          }
        ),
        c && /* @__PURE__ */ e(n.div, { display: "flex", children: /* @__PURE__ */ e(
          b,
          {
            onClick: c,
            "aria-label": "Close",
            size: "sm",
            variant: "transparent",
            sx: {
              marginRight: i ? "spacing-50" : void 0
            },
            icon: /* @__PURE__ */ e(y, { sx: t.closeButton })
          }
        ) })
      ]
    }
  ) });
}
export {
  G as Notification
};
//# sourceMappingURL=Notification.es.js.map
